export default "__VITE_ASSET__DOOTLgz7__"